import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import AddImage from "../Components/AddImage";
import DateOption1 from "../Components/DateOption1";
import InputContent from "../Components/InputContent";
import InputTitle from "../Components/InputTitle";
import RadioOption from "../Components/RadioOption";
import ImageExDetail from "../Images/imageEx_notice_banner_detail.jpg";
import ImageExPopup from "../Images/imageEx_notice_popup.jpg";
import ScreenExDetail from "../Images/screenEx_notice_detail.jpg";
import ScreenExPopup from "../Images/screenEx_notice_popup.jpg";
import Layout from "../Layout/Layout";
import AlarmApply from "../Modals/AlarmApply";
import AlarmCancel from "../Modals/AlarmCancel";
import AlarmInputCheck from "../Modals/AlarmInputCheck";
import ImageEx from "../Modals/ImageEx";
import ImageUpload from "../Modals/ImageUpload";
import "../Styles/component.css";
import "../Styles/global.css";
import { postFormData, postJson } from "../Utils/apiUtils";

const NoticeApplyContent = () => {
  const { id } = useParams();
  const isEditing = !!id;
  const navigate = useNavigate();

  const [status, setStatus] = useState(0);
  const [popupStatus, setPopupStatus] = useState(0);
  const [push, setPush] = useState(0);
  const [nation, setNation] = useState(0);

  const [popupImage, setPopupImage] = useState(null);
  const [detailImage, setDetailImage] = useState(null);

  const [startTime, setStartTime] = useState(new Date());
  const [endTime, setEndTime] = useState(new Date());

  // '예시' 버튼을 위한 state변수들
  const [clickImageEx_popup, setClickImageEx_popup] = useState(false);
  const [clickImageEx_detail, setClickImageEx_detail] = useState(false);
  const [clickUpload_popup, setClickUpload_popup] = useState(false);
  const [clickUpload_detail, setClickUpload_detail] = useState(false);
  const [inputCheckFail, setInputCheckFail] = useState(false);
  const [clickApply, setClickApply] = useState(false);
  const [clickCancel, setClickCancel] = useState(false);
  const lastNoticeDetailRequestKey = useRef(null);

  const handleClickX = () => {
    setClickImageEx_popup(false);
    setClickImageEx_detail(false);
    setClickUpload_popup(false);
    setClickUpload_detail(false);
    setInputCheckFail(false);
    setClickApply(false);
    setClickCancel(false);
  };

  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const applyButtonOK =
    popupStatus === 1 ? popupImage && startTime && endTime : title !== "";

  const handleApplyNotice = async () => {
    if (!applyButtonOK) {
      setInputCheckFail(true);
    } else {
      try {
        const _popupImage = popupImage ? popupImage[0] : null;
        const _detailImage = detailImage ? detailImage[0] : null;
        let res;

        const formData = new FormData();
        formData.append(
          "cCode",
          nation === 1 ? "kr" : nation === 2 ? "99" : "00"
        );
        formData.append("title", title);
        formData.append("content", content);
        formData.append("startTime", startTime);
        formData.append("endTime", endTime);
        formData.append("status", status === 0 ? 1 : 0);
        formData.append("popupStatus", popupStatus);
        formData.append("push", push);
        formData.append("popupImage", _popupImage);
        formData.append("image", _detailImage);

        if (isEditing) {
          formData.append("noticeId", id);
          res = await postFormData("/dashboard/notice/update", formData, navigate);
        } else {
          res = await postFormData("/dashboard/notice/create", formData, navigate);
        }

        if (res.code === 200) {
          navigate("/notice", { state: { toast_enable: true } });
        }
      } catch (error) {
        console.log("공지사항 등록 중 에러:", error);
        throw error;
      }
    }
  };

  const getNoticeData = async () => {
    try {
      const body = { noticeId: id };
      const data = await postJson("/dashboard/notice/getDetail", body, navigate);

      if (data.code === 200) {
        const _data = data.data;
        setNation(_data.cCode === "kr" ? 1 : _data.cCode === "99" ? 2 : 0);
        setTitle(_data.title);
        setContent(_data.content);
        setDetailImage(_data.image);
        setPopupImage(_data.popupImage);
        setStartTime(new Date(_data.startTime));
        setEndTime(new Date(_data.endTime));
        setStatus(_data.status === 1 ? 0 : 1);
        setPopupStatus(_data.popupStatus);
      }
    } catch (error) {
      console.log("공지사항 상세정보 가져오기 중 에러:", error);
      throw error;
    }
  };

  useEffect(() => {
    if (!isEditing) {
      return;
    }

    const requestKey = JSON.stringify({ id });

    if (lastNoticeDetailRequestKey.current === requestKey) {
      return;
    }

    lastNoticeDetailRequestKey.current = requestKey;
    getNoticeData();
  }, [id, isEditing]);

  return (
    <div>
      {clickImageEx_popup && (
        <ImageEx
          title="공지사항 - 팝업 이미지 예시"
          image={<img src={ImageExPopup} style={{ width: "536px" }} />}
          screen={<img src={ScreenExPopup} style={{ width: "536px" }} />}
          handleClickX={handleClickX}
        />
      )}
      {clickImageEx_detail && (
        <ImageEx
          title="공지사항 - 상세 이미지 예시"
          image={<img src={ImageExDetail} style={{ width: "536px" }} />}
          screen={<img src={ScreenExDetail} style={{ width: "536px" }} />}
          handleClickX={handleClickX}
        />
      )}
      {clickUpload_popup && (
        <ImageUpload
          title="팝업이미지 업로드"
          info="팝업이미지 권장 사이즈는 691x992px 입니다"
          handleClickX={handleClickX}
          pageName="NoticeApply"
          imageUpload={(img) => setPopupImage(img)}
          previewImg={popupImage}
        />
      )}
      {clickUpload_detail && (
        <ImageUpload
          title="상세이미지 업로드"
          info="상세이미지 권장 사이즈는 1000x길이자유px 입니다"
          handleClickX={handleClickX}
          pageName="NoticeApply"
          imageUpload={(img) => setDetailImage(img)}
          previewImg={detailImage}
        />
      )}
      {clickApply && (
        <AlarmApply
          title={
            isEditing
              ? "공지사항을 수정하시겠습니까?"
              : "공지사항을 등록하시겠습니까?"
          }
          subtitle="등록 시 랭킹마라톤 앱에 데이터가 반영됩니다."
          handleApply={handleApplyNotice}
          handleClickX={handleClickX}
        />
      )}
      {clickCancel && (
        <AlarmCancel
          title="작성하던 내용을 취소하시겠습니까?"
          subtitle="작성하던 내용은 저장되지 않습니다."
          handleCancel={() => navigate("/notice")}
          handleClickX={handleClickX}
        />
      )}
      {inputCheckFail && <AlarmInputCheck handleClickX={handleClickX} />}
      <NoticeApplyBox>
        <div className="title-in-box">
          공지사항 {isEditing ? "수정" : "등록"}
        </div>
        <div className="hrz-wrapper">
          <div
            className="text-for-notice"
            style={{ marginLeft: "auto", marginTop: "10px" }}
          >
            *표시는 필수 입력 항목입니다.
          </div>
        </div>

        <div className="hrz-wrapper">
          <p className="subtitle-in-box">옵션 선택</p>
        </div>
        <RadioOption
          title="앱 노출 여부*"
          noticeMessage="미노출 체크시 앱에 게시되지 않음"
          option1="노출"
          option2="미노출"
          optionChange={(optionNum) => setStatus(optionNum)}
          initialOption={status}
        />
        <RadioOption
          title="팝업 여부*"
          noticeMessage="미팝업 시 ‘설정>공지사항’에만 업로드"
          option1="미팝업"
          option2="팝업"
          optionChange={(optionNum) => setPopupStatus(optionNum)}
          initialOption={popupStatus}
          component={
            <PopupComponent
              popup={popupStatus}
              handleClickEx_popup={() => setClickImageEx_popup(true)}
              handleClickUpload={() => setClickUpload_popup(true)}
              popupImage={popupImage}
              setStartTime={setStartTime}
              setEndTime={setEndTime}
              startTime={startTime}
              endTime={endTime}
            />
          }
        />
        <RadioOption
          title="푸시 여부*"
          noticeMessage="발송 체크시 등록 즉시 구성원에게 앱 푸시 알림 발송"
          option1="미발송"
          option2="발송"
          optionChange={(optionNum) => setPush(optionNum)}
          initialOption={push}
        />
        <RadioOption
          title="노출 국가*"
          noticeMessage=""
          option1="전체"
          option2="국내"
          option3="해외"
          optionChange={(value) => setNation(value)}
          initialOption={nation}
        />

        <AddImage
          title="상세이미지"
          noticeText="상세이미지 권장 사이즈는 1000x길이자유px 입니다"
          handleClickEx={() => setClickImageEx_detail(true)}
          handleClickUpload={() => setClickUpload_detail(true)}
          previewImg={detailImage}
          page="notice"
        />

        <div className="hrz-wrapper" style={{ marginTop: "40px" }}>
          <div className="subtitle-in-box">내용 작성</div>
        </div>

        <InputTitle setTitle={(value) => setTitle(value)} title={title} />

        <InputContent
          setContent={(value) => setContent(value)}
          content={content}
          maxLength={10000}
        />

        <div style={{ display: "flex", marginTop: "30px" }}>
          <div
            className="cancelBtn center"
            style={{ marginLeft: "auto" }}
            onClick={() => setClickCancel(true)}
          >
            취소
          </div>
          <div
            className="applyBtn center"
            style={{ marginLeft: "16px" }}
            onClick={() => setClickApply(true)}
          >
            등록
          </div>
        </div>
      </NoticeApplyBox>
    </div>
  );
};

const PopupComponent = ({
  popup,
  handleClickEx_popup,
  handleClickUpload,
  popupImage,
  startTime,
  endTime,
  setStartTime,
  setEndTime,
}) => {
  return (
    <div>
      {popup === 1 && (
        <div>
          <AddImage
            title="팝업이미지*"
            noticeText="팝업이미지 권장 사이즈는 690x990px 입니다"
            handleClickEx={handleClickEx_popup}
            handleClickUpload={handleClickUpload}
            previewImg={popupImage}
            page="notice"
          />
          <div className="hrz-wrapper" style={{ marginTop: "40px" }}>
            <DateOption1
              startTitle="시작일*"
              endTitle="종료일*"
              gap="20px"
              setStartDate={setStartTime}
              setEndDate={setEndTime}
              startDate={startTime}
              endDate={endTime}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const NoticeApplyBox = styled.div`
  width: auto;
  height: auto;
  border-radius: 20px;
  margin-left: 413px;
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 30px;
  background-color: #ffffff;
`;

const NoticeApply = () => {
  return <Layout page={<NoticeApplyContent />} />;
};

export default NoticeApply;
